import { z } from "zod";

export const MethodsInputSchema = z.object({
  id: z.number().positive().min(1),
  captureId: z.number().positive().min(1),
  name: z.string().nullable().optional(),
  exploitationFlow: z.number().nullable().optional(),
  testFlow: z.number().nullable().optional(),
  flowM3Day: z.number().nullable().optional(),
  flowM3Hour: z.number().nullable().optional(),
  hydrostaticLevel: z.number().nullable().optional(),
  hydrodynamicLevel: z.number().nullable().optional(),
  transmissivity: z.number().nullable().optional(),
  hydraulicConductivity: z.number().nullable().optional(),
  hydraulicGradient: z.number().nullable().optional(),
  effectivePorosity: z.number().nullable().optional(),
  storageCoefficient: z.number().nullable().optional(),
  recharge: z.number().nullable().optional(),
  saturatedThickness: z.number().nullable().optional(),
  saturatedThicknessTop: z.number().nullable().optional(),
  saturatedThicknessBase: z.number().nullable().optional(),
  aquiferType: z.number().int().min(1).max(6).nullable().optional(),
  createdOn: z.date(),
  modifiedOn: z.date(),
  createdBy: z.number().positive().min(1),
  modifiedBy: z.number().positive().min(1),
  active: z.boolean(),
});

export type MethodsInput = z.infer<typeof MethodsInputSchema>;